import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { ModalService } from '../../services/modal.service';

declare var bootstrap: any;

@Component({
  selector: 'app-modal',
  imports: [],
  templateUrl: './modal.component.html',
})
export class ModalComponent {

  @Input() id!: string;
  @ViewChild('modalElement') modalElement!: ElementRef;

  modalService = inject(ModalService);

  private modalInstance!: any

  ngAfterViewInit(): void {
    this.modalInstance = new bootstrap.Modal(this.modalElement.nativeElement);
    this.modalService.register(this.id, this);
  }

  open(): void {
    this.modalInstance.show();
  }

  close(): void {
    this.modalInstance.hide();
  }

  ngOnDestroy(): void {
    this.modalService.unregister(this.id);
  }
}
